import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntitySales } from "../../entity/EntitySales";

export class DtoSalessGetRes extends EntitySales {
  public items: EntitySales[]  = [];
}
